import { DELETE_ADMISSION, GET_ADMISSION, SET_ADMISSION } from "./actionType";

export const addAdmission = (data) => {
  return {
    type: SET_ADMISSION,
    payload: data,
  };
};

export const getAdmission = (admissionData) => {
  return {
    type: GET_ADMISSION,
    payload: admissionData,
  };
};

export const deleteAdmission = (id) => {
  return {
    type: DELETE_ADMISSION,
    payload: id,
  }
}